<ion-content class="theme-{{userService.theme}}">
    <div class="manager-wrap">
        <app-header></app-header>

        <div class="content-wrap-inner">
            <div class="small-title" *ngIf="pageData !== null">{{pageData.program.title}}</div>
            <div class="title-top">
                <span class="my-color-blue">{{'__JOURNEY_LEARNING_JOURNEY__' | translate}}</span>
                <img src="assets/img/location.svg" alt="#">
            </div>
        </div>
    </div>
    <app-learning-journey-programm-template
            *ngIf="pageData !== null" [saveForm]="saveForm" [level]="'manager'" [stage]=""
            [programDelegate]="pageData"></app-learning-journey-programm-template>
</ion-content>
<ion-footer>
    <app-footer (saveEvent)="onSave()" [backButton]="true" [saveButton]="true"></app-footer>
</ion-footer>
